/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import {TriggerListPageComponent} from './trigger-list-page.component';

@Component({
  standalone: true,
  imports: [TriggerListPageComponent],
  selector: 'adn-trigger-route-page',
  template: `
    <adn-trigger-list-page
      [readOnly]="readOnly">
    </adn-trigger-list-page>
  `
})
export class TriggerRoutePageComponent {
  @Input() readOnly = false;
}
